/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-06 11:19:17
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-07 03:48:55
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/Components/Stock/index.tsx
 */
import React from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';

import { SectionCollapse, SizeFittingTable } from '@/src/components/Antd';
import { Icon } from '@/src/tools/icon';
import { ProductItem } from '@/src/types/common/product';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from './style.module.less';
type Props = {
  products: Array<ProductItem>;
};

function Stock({ products }: Props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const history = useHistory();
  const navigateToProduct = (uuid: string, record: any) => {
    if (record.productType === 'Simple') {
      history.push(`/product/simpleProduct/${uuid}`);
    } else if (record.productType === 'Set') {
      history.push(`/product/productSet/${uuid}`);
    } else {
      history.push(`/product/virtualProduct/${uuid}`);
    }
  };

  const columns = [
    {
      width: 32,
      default: true,
      title: '',
      key: 'index',
      childGenerate: (_, __, index: number) => index + 1,
    },
    {
      title: getI18n('general.storeCommunicationSetting.product'),
      dataIndex: 'name',
      default: true,
      minWidth: 320,
      childGenerate: (text, _, index: number) => {
        return (
          <div className={styles.product}>
            <div className={styles.text}>{text}</div>
          </div>
        );
      },
    },
    {
      title: getI18n('salesChannelProductDetail.index.thisSalesChannel'),
      default: true,
      minWidth: 320,
      children: [
        {
          title: getI18n('general.stock'),
          dataIndex: 'salesChannelStock',
          default: true,
          render: (text) => {
            return text ? text.stock : '';
          },
        },
        {
          title: getI18n('salesChannelProductDetail.index.presale'),
          dataIndex: 'salesChannelStock',
          default: true,
          render: (text) => {
            return text ? text.presale : '';
          },
        },
        {
          title: getI18n('salesChannelProductDetail.index.availableforSale'),
          dataIndex: 'salesChannelStock',
          default: true,
          render: (text) => {
            return text ? text.available : '';
          },
        },
      ],
    },
    {
      title: getI18n('salesChannelProductDetail.index.total'),
      default: true,
      minWidth: 320,
      children: [
        {
          title: getI18n('general.stock'),
          dataIndex: 'totalStock',
          default: true,
          render: (text) => {
            return text ? text.stock : '';
          },
        },
        {
          title: getI18n('salesChannelProductDetail.index.presale'),
          dataIndex: 'totalStock',
          default: true,
          render: (text) => {
            return text ? text.presale : '';
          },
        },
        {
          title: getI18n('salesChannelProductDetail.index.availableforSale'),
          dataIndex: 'totalStock',
          default: true,
          render: (text) => {
            return text ? text.available : '';
          },
        },
      ],
    },
    {
      title: '',
      default: true,
      dataIndex: 'uuid',
      width: 142,
      childGenerate: (text, record, index: number) => {
        return (
          <div
            className={styles.action}
            onClick={navigateToProduct.bind(this, text, record)}>
            {getI18n('salesChannelProductDetail.index.gotoProduct')}
          </div>
        );
      },
    },
  ];

  const renderContent = () => {
    return (
      <div className={styles.content}>
        <SizeFittingTable
          id={'stock'}
          rowKey={'uuid'}
          bordered
          rowClassName={styles.row}
          className={styles.table}
          pagination={false}
          columns={columns}
          dataSource={products}
        />
        {renderBottom()}
      </div>
    );
  };

  const renderBottom = () => {
    return (
      <div className={styles.bottom}>
        <Icon type='iconinfo' className={styles.icon} />
        <span>
          {`${getI18n('general.gotoStore')} >`}{' '}
          <Link to={'/productsList'}>
            {getI18n('general.storeCommunicationSetting.product')}
          </Link>{' '}
          {getI18n('salesChannelProductDetail.index.tomanagestock')}
        </span>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <SectionCollapse
        open={true}
        id={'salesChannelLinkProductStock'}
        titleStyle={{ height: '64px' }}
        title={
          <div className={'collapseTitle'}>{getI18n('general.stock')}</div>
        }
        content={renderContent()}
        openMargin={16}
      />
    </div>
  );
}

export default Stock;
